module.exports = __webpack_public_path__ + "static/media/office4.baf4c51d.jpg";